console.log(`
\ _   _      _ _         _____ _
| | | | ___| | | ___   |_   _| |__   ___ _ __ ___
| |_| |/ _ \\ | |/ _ \\    | | | '_ \\ / _ \\ '__/ _ \\
|  _  |  __/ | | (_) |   | | | | | |  __/ | |  __/
|_| |_|\\___|_|_|\\___/    |_| |_| |_|\\___|_|  \\___|
`);

/* +-----------------------------------------+
|           GLOBALS AREA             		 |
+-----------------------------------------+ */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger);
// gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

window.DEBUG = false;
window.MNK = !ScrollTrigger.isTouch;
window.TOUCH = !!ScrollTrigger.isTouch;

/* +-----------------------------------------+
|           IMPORTS AREA             		 |
+-----------------------------------------+ */

// Swiper
import initSwipers from "./swiper/initSwipers";

// CSS
import "../assets/icons/scss/icons.scss";
import "../styles/bootstrap/bootstrap.scss";
import "../styles/frontend.scss";

// Bootstrap
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/tab";

// GSAP
import initGsap from "./gsap/initGsap";
import initGsapTriggers from "./gsap/utilities/initGsapTriggers";
import initGsapLenis from "./gsap/utilities/initGsapLenis";
import gsapScrollTo from "./gsap/utilities/gsapScrollTo";

// Utilities
import initLoader from "./utilities/initLoader";
import getDimensions from "./utilities/getDimensions";
import initMouseFollower from "./utilities/initMouseFollower";
import initGlightbox from "./utilities/initGlightbox";
import initReadSmore from "./utilities/initReadSmore";
import kobleQuickView from "./utilities/kobleQuickView";
import initMaps from "./utilities/initMaps";
import appendToBody from "./utilities/appendToBody";
import togglePairedCheckboxes from "./utilities/togglePairedCheckboxes";
import initToastify from "./utilities/initToastify";
import initShare from "./utilities/initShare";
import currencySwitcher from "./utilities/currencySwitcher";
import initCleave from "./utilities/initCleave";
import openModalByUrl from "./utilities/openModalByUrl";
import initDrawer from "./utilities/initDrawer";
import getStickyElements from "./utilities/getStickyElements";
import initMultidescription from "./utilities/initMultidescription";
import initDownload from "./utilities/initDownload";
import galleryViewMore from "./utilities/galleryViewMore";


/* +-----------------------------------------+
|           EVENTS AREA             		 |
+-----------------------------------------+ */

// DOC Ready
document.addEventListener(
    "DOMContentLoaded",
    () => {
        getDimensions("#app-header", "height");
        getDimensions("#app-topbar", "height");
        getDimensions("#app-navbar", "height");

        initGsapLenis();

        initReadSmore();

        initSwipers();
        initGlightbox();
        kobleQuickView();
        initMaps();
        togglePairedCheckboxes();
        initToastify();
        initShare();
        currencySwitcher();
        initCleave();
        openModalByUrl();
        initDrawer();
        initMultidescription();
        initDownload();
        galleryViewMore();
    },
    { once: true }
);

// WINDOW Ready
window.addEventListener(
    "load",
    () => {
        initGsap();
        initGsapTriggers();

        // requestAnimationFrame(() => {
        //     ScrollSmoother.refresh(true);
        //     ScrollTrigger.refresh(true);
        //     console.log("refresh");
        // });

        // setTimeout(() => {
        //     ScrollSmoother.refresh(true);
        //     ScrollTrigger.refresh(true);
        //     console.log("refresh");
        // }, 3000);

        getStickyElements();
        appendToBody(".modal");

        // if (MNK) initMouseFollower();

        initLoader();

        const hash = window.location.hash;
        if (hash) gsapScrollTo(hash);
    },
    { once: true }
);

// WS Form
(function ($) {
    $(document).on("wsf-rendered", () => {
        getDimensions(".iti__flag-container", "width");
        getDimensions("input.wsf-field", "height");
    });

    $(document).on(
        "wsf-validate-after",
        function (
            event,
            form_object,
            form_id,
            instance_id,
            form_el,
            form_canvas_el
        ) {
            const transitionSpeed = parseFloat(
                getComputedStyle(form_el[0])
                    .getPropertyValue("--wsf-form-transition-speed")
                    .replace("ms", "")
                    .trim()
            );

            setTimeout(getStickyElements, transitionSpeed);
        }
    );
})(jQuery);
